// api.js
import axios from 'axios';
// It's good practice to import config if baseURL might come from there,
// though your current setup directly uses process.env.NODE_ENV.
// import config from './config'; 

let baseURL;

// Check the environment to set the base URL
if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://radian-360.wn.r.appspot.com'; 
} else {
    baseURL = 'http://localhost:5000'; 
}

const api = axios.create({
    baseURL: baseURL,
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add the response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => {
    // If the request was successful, just return the response
    return response;
  },
  (error) => {
    // Check if the error is specifically a 401 Unauthorized
    if (error.response && error.response.status === 401) {
      console.warn("API request unauthorized (401). Token might be expired or invalid.");
      
      // Clear token and user details from localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userName');
      localStorage.removeItem('userCohortId');
      
      // Dispatch the 'authChanged' event. App.js is already listening for this.
      // This event will trigger syncAuthState in App.js, which updates the isLoggedIn state.
      window.dispatchEvent(new Event('authChanged')); 

      // Redirect to the login page if not already there
      // This ensures that if the auth state change doesn't immediately cause a redirect
      // via protected route logic, the user is still sent to login.
      if (window.location.pathname !== '/login' && window.location.pathname !== '/home') {
        // Add a small delay to allow App.js to process the authChanged event if necessary,
        // though often the state update in App.js and route protection handle it.
        // For a more robust solution, App.js could directly handle the redirect
        // upon detecting isLoggedIn is false on a protected route.
        // However, for an immediate redirect from the interceptor:
        window.location.href = '/login'; 
      }
    }
    // For other errors, just reject the promise so they can be handled locally if needed
    return Promise.reject(error);
  }
);

export default api;
